import { capitalize } from "@core/utils";
import type { ItemCategory } from '@src/types'
import type { Product } from "./types";

export const getItemCategory = (item: Product): ItemCategory => {
  const value = item?.category;
  if (!value) return "Coleção";

  const text = Array.isArray(value) ? value.join(" ") : String(value);
  const match = text.match(/outlet|bazar|sale/i)?.[0].toLowerCase();
  return (match as ItemCategory) ?? "Coleção";
};

export const getItemCategory2 = (item: Product): string => {
  const AVOID_CATEGORIES = /^(outlet|bazar|sale)$/i;
  const categories = item.category?.split(">") ?? [];
  const last = categories[categories.length - 1] ?? "";
  const validHierarchy = last
    .split("/")
    .filter((c: string) => c && !AVOID_CATEGORIES.test(c));
  const deepest = validHierarchy[validHierarchy.length - 1] ?? "";
  return capitalize(deepest);
};